import {
  Button,
  Col,
  Input,
  InputProps,
  Row,
  Slider,
  SliderSingleProps,
} from "antd";
import { SliderRangeProps } from "antd/lib/slider";
import { FilterDropdownProps } from "antd/lib/table/interface";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import deleteFromObject from "src/shared/function/deleteFromObject";
import { queryParse } from "src/shared/function/queryParse";
import useFilter from "src/shared/hooks/useFilter";
import { FormC, FormItemC, InputNumberC } from "..";
import "../../../themes/global.less";

interface FilterDropDownCProps extends FilterDropdownProps {
  type: "input" | "slider" | "select" | "date";
  min?: number;
  max?: number;
  dataIndex: string;
  title?: string;
  sliderProps?: SliderSingleProps | SliderRangeProps;
  inputProps?: InputProps;
}
const FilterDropDownC = (props: FilterDropDownCProps) => {
  const { t } = useTranslation();
  const { onFilter } = useFilter();
  const {
    location: { search },
  } = useHistory();
  const query = queryParse(search);
  const {
    type,
    confirm,
    prefixCls,
    selectedKeys,
    setSelectedKeys,
    visible,
    clearFilters,
    filters,
    dataIndex,
    title,
    sliderProps,
    max,
    min,
    inputProps,
  } = props;

  const [valueState, setValueState] = useState<any>([]);
  const handleSearch = (selectedKeys: any, confirm: any, dataIndex: any) => {
    confirm();
  };

  //   useEffect(() => {
  //     if (selectedKeys?.length) {
  //       setValueState(selectedKeys);
  //     }
  //   }, [selectedKeys]);
  const handleReset = (clearFilters: any) => {
    console.log("dataIndex", dataIndex);
    onFilter(deleteFromObject(query, [dataIndex]), { isAssign: false });
    clearFilters();
  };
  const Temp = ({ children }: any) => {
    return (
      <div style={{ padding: 8 }}>
        <FormC
          onFinish={(e) => {
            handleSearch(selectedKeys, confirm, dataIndex);
          }}
        >
          {children}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              onClick={() => handleReset(clearFilters)}
              size="small"
              style={{ width: 90 }}
              block
              htmlType="reset"
            >
              {t("reset")}
            </Button>
            <Button
              type="primary"
              size="small"
              style={{ width: 90 }}
              block
              htmlType="submit"
            >
              {t("search")}
            </Button>
          </div>
        </FormC>
      </div>
    );
  };

  switch (type) {
    case "slider":
      return (
        <Temp>
          <Row gutter={[10, 5]} style={{ width: "250px" }}>
            {sliderProps?.range == false ? (
              <Col span={12}>
                <InputNumberC
                  formItem={{ name: "value", initialValue: selectedKeys[0] }}
                />
              </Col>
            ) : (
              <Col span={24}>
                <Row gutter={[10, 10]} justify="space-between">
                  <InputNumberC
                    formItem={{
                      name: ["value", 0],
                      initialValue: selectedKeys[0],
                    }}
                    col={{ span: 12 }}
                    placeholder={t("min")}
                    onChange={(e) =>
                      selectedKeys?.length == 2
                        ? setSelectedKeys([Number(e), selectedKeys[1]])
                        : setSelectedKeys([Number(e), max as any])
                    }
                    // value={selectedKeys[0]}
                  />
                  <InputNumberC
                    formItem={{
                      name: ["value", 1],
                      initialValue: selectedKeys[1],
                      dependencies: ["value", 0],
                      rules: [
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (
                              (value || value == 0) &&
                              Number(getFieldValue(["value", 0])) <=
                                Number(value)
                            ) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              "حداکثر باید از حداقل بیشتر باشد"
                            );
                          },
                        }),
                      ],
                    }}
                    col={{ span: 12 }}
                    placeholder={t("max")}
                    onChange={(e) =>
                      selectedKeys?.length == 2
                        ? setSelectedKeys([selectedKeys[0], e])
                        : setSelectedKeys([min as any, Number(e)])
                    }
                    // value={selectedKeys[1]}
                  />
                </Row>
              </Col>
            )}
            <Col span={24}>
              <FormItemC
                name="value"
                initialValue={
                  selectedKeys.length
                    ? (selectedKeys as [number, number])
                    : [min as number, max as number]
                }
              >
                <Slider
                  range
                  min={min}
                  max={max}
                  tooltipVisible={visible}
                  tooltipPlacement="bottom"
                  defaultValue={
                    selectedKeys.length
                      ? (selectedKeys as [number, number])
                      : [min as number, max as number]
                  }
                  // style={{ marginBottom: 8, display: "block" }}
                  onChange={(e) => {
                    if (Array.isArray(e)) {
                      setSelectedKeys(e);
                      setValueState(e);
                    } else {
                      setSelectedKeys([e]);
                      setValueState([e]);
                    }
                  }}
                  {...(sliderProps as any)}
                />
              </FormItemC>
            </Col>
          </Row>
        </Temp>
      );
      break;

    case "input":
      return (
        <Temp>
          <Input
            autoFocus
            placeholder={`${t("search")} ${title ? t(title) : ""}`}
            defaultValue={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ marginBottom: 8, display: "block" }}
            {...inputProps}
          />
        </Temp>
      );

    case "date":
      return (
        <Temp>
          <FormItemC
            name="value"
            // initialValue={[
            //   moment(new Date().getTime()),
            //   moment(new Date().getTime()),
            // ]}
            style={{ marginBottom: "5px" }}
          ></FormItemC>
        </Temp>
      );
  }

  return <div></div>;
};

export default FilterDropDownC;
